module.exports = __webpack_public_path__ + "img/comunicativo.7a2203a2.svg";